import { render, staticRenderFns } from "./staff_card1.vue?vue&type=template&id=3a7ccae8&scoped=true&"
import script from "./staff_card1.vue?vue&type=script&lang=js&"
export * from "./staff_card1.vue?vue&type=script&lang=js&"
import style0 from "./staff_card1.vue?vue&type=style&index=0&id=3a7ccae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ccae8",
  null
  
)

export default component.exports